import { SipService } from 'Modules/softphone/services/SipService';
import { searchPersonBySip } from 'Utils/searchPersonBySip';

/**
 * Helper functions for working with SIP URIs and related operations.
 */
export function normalizeSipUri(uri: string): string {
  let normalized = uri.replace(/\s/g, '');

  if (!normalized.includes('sip:')) {
    normalized = 'sip:' + normalized;
  }

  return normalized;
}

/**
 * Searches for a person by extension, building the SIP URI and returning the corresponding `sourceId`.
 *
 * @param extension - The extension to search for (e.g., `"1001"`).
 * @param domain - Optional SIP domain. If not provided, uses the domain from the active `SipService` configuration.
 * @returns The `sourceId` of the person found, or `undefined` if no domain is configured or no results are found.
 */
export async function resolvePersonByExtension(
  extension: string,
  domain?: string
): Promise<string | undefined> {
  try {
    const resolvedDomain =
      domain ?? SipService.getInstance().getConfig()?.domain;
    if (!resolvedDomain) {
      return undefined;
    };

    const match = await searchPersonBySip(`${extension}@${resolvedDomain}`);
    return match?.sourceId ?? undefined;
  } catch {
    return undefined;
  }
}
